import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { PurchaseOrder } from '../../../inventory/orders/order-received/order-received.component';
import { PurchaseOrderResponse } from 'src/app/models/purchase-order.model';
@Component({
  selector: 'app-total-purchase-order-calendar-days',
  templateUrl: './total-purchase-order-calendar-days.component.html',
  styleUrls: ['./total-purchase-order-calendar-days.component.scss']
})
export class TotalPurchaseOrderCalendarDaysComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  @Input() productId: number;
  @Input() productName: string;
  @Input() startDate: any;
  @Input() endDate: any;
  details: PurchaseOrderResponse[] = [];
  totalPurchase = 0;
  loading = false;

  constructor(
    private toastService: ToastrService,
    private purchaseOrderService: PurchaseOrderService
  ){}

  ngOnInit() {
    this.getData();
  }

  getData(){
    if(!this.productId || !this.startDate || !this.endDate) {
      return;
    }
    this.loading = true;
    this.purchaseOrderService.getReportPurchaseOrderFromWeeks(this.productId, this.startDate, this.endDate).subscribe({
      next: (response: ResponseObject) => {
        this.details = response.data;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se obtuvieron las ordenes del producto", "Error")
        this.loading = false;
      }
    });
  }

  closeModal(modal: ModalDialogComponent) {
      modal.onClose();
      this.closed.emit();
    }
  
  close() {
    this.closed.emit();
    this.showModal = false;
  }

  // Escucha global de la tecla Escape
  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    if (this.showModal) {
      this.close();
    }
  }
}
